<template>
    <div>
        <a class="btn btn-success mt-1 mb-2 px-2 text-white w-full text-left"
           :href="`${cpixdomain}/aspen/propertyboost.htm`" ignore>
            <i class="text-green-300 mr-2 fas fa-rocket"></i> Core PropertyBoost
        </a>
        <a class="inline-block w-full mb-2 py-2 px-2 rounded bg-gray-100 hover:text-gray-700 text-gray-700"
           :href="`${cpixdomain}/aspen/listingEPostcard.htm`"
           target="_blank"
           v-show="!hideEpostcard()">
          <i class="text-gray-300 mr-2 fas fa-envelope"></i> Send <span ignore>ePostcard</span>
        </a>

        <a class="inline-block w-full mb-2 py-2 px-2 rounded bg-gray-100 hover:text-gray-700 text-gray-700"
           :href="`${cpixdomain}/aspen/flyerLinks2.htm?tourId=${listing.id}&navigation=clm`"
           v-show="!hideMarketingMaterials()">
            <i class="text-gray-300 mr-2 fas fa-print"></i> {{printCenterText}}
        </a>
        <a class="inline-block w-full mb-2 py-2 px-2 rounded bg-gray-100 hover:text-gray-700 text-gray-700"
           :href="`${cpixdomain}/aspen/listingOpenHouse.htm`"
           target="_blank">
            <i class="text-gray-300 mr-2 fas fa-home "></i> Open House
        </a>
        <a class="inline-block w-full mb-2 py-2 px-2 rounded bg-gray-100 hover:text-gray-700 text-gray-700"
           :href="`${cpixdomain}/aspen/craigslist.htm`"
           target="_blank">
          <i class="text-gray-300 mr-2 fas fa-plus-circle"></i> Post to <span ignore>Craigslist</span>
        </a>
    </div>
</template>

<script>
    // TODO: Add propertyboost
    import {cpixdomain} from "../../config";
    import {mapGetters} from "vuex";

    export default {

      computed: {
          cpixdomain() {
              return cpixdomain
          },
        ...mapGetters([
          'me'
        ]),
        printCenterText() {
          if(this.me.tokenUser.company.CMPid === 102999 || this.me.tokenUser.company.parentCMPid === 102999) {
            return "Print Centre";
          }
          return "Print Center";
        }
      },
      methods: {
        hideMarketingMaterials() {
          if(typeof this.me.tokenUser.company.preferences[712] !== 'undefined') {
            return this.me.tokenUser.company.preferences[712].PREFvalue === "true";
          }

          return false;
        },
        hideEpostcard() {
          if(typeof this.me.tokenUser.company.preferences[717] !== 'undefined') {
            return this.me.tokenUser.company.preferences[717].PREFvalue === "true";
          }

          return false;
        }
      },
      props: ['listing']
    }

</script>


<style scoped lang="scss">

</style>
